import { membershipAppHomePath, isMembershipExperience } from './isMembershipExperience';
import { usesOfficeDashboard } from './seesAgencyListings';
import { isPlatformAdmin } from './founderAccess';

/** The acting platform administrator, not a hopped office seat. */
export function isPlatformAdminUser(user) {
  return isPlatformAdmin(user);
}

/** Where an invited / logged-in user lands after password. */
export function homePathForUser(user) {
  if (!user) return '/dashboard';
  if (isMembershipExperience(user)) return membershipAppHomePath(user);
  const role = String(user.role || '').toLowerCase();
  const pt = String(user.partnerType || '').toLowerCase();
  if (isPlatformAdminUser(user)) return '/admin';
  if (role === 'partner_enterprise') return '/partner-enterprise-dashboard';
  if (role === 'enterprise') return '/enterprise-dashboard';
  if ((role === 'partner' || role === 'partner_agent') && pt === 'bond_originator') return '/bond-originator';
  if (role === 'partner' && pt === 'conveyancer') return '/conveyancer';
  if (role === 'partner' || role === 'partner_agent') return '/partner-dashboard';
  if (role === 'branch_manager') return '/my-reports';
  if (usesOfficeDashboard(user)) return '/dashboard';
  if (role === 'agent' || role === 'independent_agent' || role === 'agency_agent') return '/agent-dashboard';
  if (role === 'seller') return '/dashboard';
  if (role === 'investor' || role === 'buyer') return '/investor-portfolio';
  return '/dashboard';
}

export function goHome(user) {
  const path = homePathForUser(user);
  const cacheBuster = path.includes('?') ? `&r=${Date.now()}` : `?r=${Date.now()}`;
  window.location.href = path + cacheBuster;
}
